<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col>
                <router-link :to="{ name: 'member_info_list', params: { search:$route.params.search } }" class="btn btn-ptc1" tag="button">返回</router-link>
            </b-col>
            <b-col class="text-center title">會員管理 / 會員查詢 / 電子券使用紀錄({{this.$route.params.membername}})</b-col>
            <b-col>
                <div class="text-right">
                    <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                <b-card class="bg-default-card">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="p-4 box-shadow" header="Form Elements">
                                <div class="row">
                                    <label class="control-label col-md-3">品牌：</label>
                                    <div class="col-md-3">
                                      <select
                                              id="brands-code"
                                              name="brandsCode"
                                              class="form-control"
                                              v-model="model.brandCode"
                                            >
                                            <option
                                              v-for="x in selectListBrands"
                                              v-bind:value="x.Code"
                                              :key="x.Code"
                                            >{{x.Text}}</option>
                                      </select>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <label class="control-label col-md-3">關鍵字：</label>
                                    <div class="col-md-3">
                                        <input type="text" class="form-control" v-model="model.searchtext" placeholder="請輸入關鍵字搜尋">
                                    </div>
                                </div>
                                <div class="form-group p-10 row mt-3">
                                    <div class="col-3 ">狀態：</div>
                                    <b-form-radio-group class="row col-9 mb-2" v-model="model.status">
                                        <div class="col-lg-3 col-md-3">
                                            <div class="custom-controls-stacked">
                                                <b-form-radio checked="false" class="primaryradio" name="status" value="0">全部</b-form-radio>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-3">
                                            <div class="custom-controls-stacked">
                                                <b-form-radio class="primaryradio" name="status" value="2">已過期</b-form-radio>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-3">
                                            <b-form-radio checked="false" class="primaryradio" name="status" value="1">已使用
                                            </b-form-radio>
                                        </div>
                                    </b-form-radio-group>
                                </div>
                                <div class="row mt-3">
                                    <label class="control-label col-md-3">使用/過期日期區間：</label>
                                    <div class="col-md-3">
                                        <input type="date" class="form-control" v-model="model.sdate" max="9999-12-31" @input="changeDate($event, 1)" v-on:keydown="keydownDate($event, 1)">
                                    </div>
                                    <label class="control-label">至</label>
                                    <div class="col-md-3">
                                        <input type="date" class="form-control" v-model="model.edate" max="9999-12-31" @input="changeDate($event, 2)" v-on:keydown="keydownDate($event, 2)">
                                    </div>
                                    <div class="col-md-2">
                                        <button type="button" class="btn btn-warning text-white " @click="search()">查詢</button>
                                        <button type="button" class="btn btn-warning text-white" @click="reset()">重設</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
            </b-collapse>
            <!-- First Basic Table Ends Here-->
            <!-- Second Data Table Starts Here-->
            <div class="row">
                <div class="col-lg-12 mb-3">
                    <b-card class="bg-default-card">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="p-4 box-shadow" header="Form Elements">
                                    <div class="table-responsive">
                                        <table id="mytable" class="table table-bordred table-striped">
                                            <thead>
                                                <tr>
                                                    <th>品牌</th>
                                                    <th>票券代號</th>
                                                    <th>票券名稱</th>
                                                    <th>狀態</th>
                                                    <th>使用/過期日期</th>
                                                    <th>使用門市</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="v in Datalist" :key="v.id">
                                                    <td>{{ v.BrandCode }}</td>
                                                    <td>{{ v.Code }}</td>
                                                    <td>{{ v.Name }}</td>
                                                    <td>{{ (v.Status===1) ? '已使用':'已過期'}}</td>
                                                    <td v-if="v.Status===1">{{ v.UsedAt | formatDate }}</td>
                                                    <td v-if="v.Status!==1">{{ v.UsedAt | formatDate1 }}</td>
                                                    <td>{{ v.StoreName }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row" style="padding: 0 1rem">
                                        <b-pagination size="md" :total-rows="model.count" v-model="model.currentPage" :per-page="model.rows" @change="giftcertificatehistories" :value="model.currentPage"></b-pagination>
                                        <label style="margin:8px">{{model.startRowNum}}到{{model.endRowNum}}，總共 {{model.count}}筆</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </div>
            </div>
            <!-- second row ends here -->
            <!-- Fourth Basic Table Starts Here-->
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import VueForm from 'vue-form'
import options from 'validations'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
Vue.use(VueForm, options)
export default {
  name: 'add_user',
  data () {
    return {
      formstate: {},
      sdateInvalid: false,
      edateInvalid: false,
      passwordtext: '',
      model: {
        searchtext: '',
        sdate: '',
        edate: '',
        status: '0',
        currentPage: 1,
        rows: 20,
        count: 0,
        startRowNum: 0,
        endRowNum: 0,
        brandCode: ''
      },
      Datalist: [],
      old_file: '',
      selectListBrands: [{ ID: 0, Code: '', Text: '全部' }]
    }
  },
  methods: {
    changeDate (e, type) {
      // 日期變更事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    keydownDate (e, type) {
      // 日期輸入事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    giftcertificatehistories (currentPage) {
      if (this.$route.params.memberid === undefined) {
        this.$router.push({ name: 'member_info_list' })
        return
      }
      var edate = '9999-12-31'
      if (this.model.edate !== '') {
        edate = this.model.edate
      }
      if (this.model.sdate > edate) {
        miniToastr.error('請選擇正確的效期確的使用/過期日期區間')
        return
      }
      if (this.sdateInvalid || this.edateInvalid) {
        miniToastr.error('日期格式輸入錯誤，請重新輸入')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/member/giftcertificatehistories/v1', {
        memberid: this.$route.params.memberid,
        brandcode: this.model.brandCode,
        keyword: this.model.searchtext,
        status: parseInt(this.model.status),
        startdate: this.model.sdate,
        enddate: edate,
        page: currentPage,
        rows: this.model.rows
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.model.count = (response.data.count === undefined) ? 0 : response.data.count
            this.Datalist = response.data.memberreferencelist
            this.model.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.model.rows * (this.model.currentPage - 1) + 1
            this.model.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.model.rows > response.data.count) ? response.data.count : (this.model.currentPage * this.model.rows) >= response.data.count ? response.data.count : this.model.currentPage * this.model.rows
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            console.log(response)
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
        })
    },
    search () {
      this.model.currentPage = 1
      this.giftcertificatehistories(1)
    },
    datevalidationcheck (str) {
      var sdchack = ''
      sdchack = this.datevalidationcheck(this.model.sdate)
      if (!sdchack) {
        miniToastr.error('開始日期錯誤')
        return
      }
      var re = new RegExp('^([0-9]{4})[.-]{1}([0-9]{1,2})[.-]{1}([0-9]{1,2})$')
      var strDataValue
      var infoValidation = true
      if ((strDataValue = re.exec(str)) != null) {
        var i
        i = parseFloat(strDataValue[1])
        if (i <= 0 || i > 9999) {
          infoValidation = false
        }
        i = parseFloat(strDataValue[2])
        if (i <= 0 || i > 12) {
          infoValidation = false
        }
        i = parseFloat(strDataValue[3])
        if (i <= 0 || i > 31) {
          infoValidation = false
        }
      } else {
        infoValidation = false
      }
      return infoValidation
    },
    reset () {
      this.model.status = '0'
      this.model.searchtext = ''
      this.setdate()
      this.model.currentPage = 1
      this.sdateInvalid = false
      this.edateInvalid = false
      this.model.brandCode = ''
      this.querySelectListBrands()
      this.giftcertificatehistories(1)
    },
    setdate () {
      var date = new Date()
      date.setMonth(date.getMonth() - 3)
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.model.sdate = year + '-' + mon + '-' + day
      this.model.edate = ''
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          response.data.data.forEach(item => {
              if (!this.selectListBrands.some(existingItem => existingItem.ID === item.ID)) {
                  this.selectListBrands.push(item)
              }
          })
          this.$parent.Loading = false
        })
        .catch(error => {
          this.selectListBrands = []
          this.$parent.Loading = false
          miniToastr.error(error, "資料讀取異常")
          console.log(error)
        })
    }
  },
  mounted: function () {

  },
  destroyed: function () {

  },
  beforeMount: function () {
    this.setdate()
    this.giftcertificatehistories(1)
    this.querySelectListBrands();
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
      var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
      var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      var retext = year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds
      if (retext === '1-01-01 08:06:00') {
        retext = ''
      }
      return retext
    },
    formatDate1: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      if (month < 10) {
        month = '0' + month
      }
      var retext = year + '/' + month + '/' + day
      if (retext === '1-1-01') {
        retext = ''
      }
      return retext
    }
  },
  created () {
    this.setdate()
    this.giftcertificatehistories(1)
    this.FunctionPermission = getFunctionPermission('F07') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  }
}
</script>
<style scoped>
    .box-shadow {
        box-shadow: 0px 0px 1px 1px #cfcfcf;
    }
</style>



// WEBPACK FOOTER //
// src/pages/member/info/CouponHistory.vue